// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1LE4s","col":"styles_col__EOcwT"};